"use client"

import React, { PropsWithChildren, useState } from "react"

import { cn } from "@/components/ui/helpers/utils"
import { useClickOutside } from "@/components/ui/hooks/click-outside-hook"

interface ProductDetailBuyboxOrderFeaturePopupProps extends PropsWithChildren {
  label: string
}

export default function ProductDetailBuyboxOfferFeaturePopupClient(props: ProductDetailBuyboxOrderFeaturePopupProps) {
  const [popupVisible, setPopupVisible] = useState(false)
  const ref = useClickOutside<HTMLDivElement>(() => setPopupVisible(false))

  return (
    <div className="relative" ref={ref}>
      <button
        className="underline hover:text-primary hover:no-underline"
        onClick={() => setPopupVisible(!popupVisible)}
      >
        {props.label}
      </button>
      <div
        className={cn("absolute bottom-8 right-0 w-max max-w-none border drop-shadow-md", {
          hidden: !popupVisible,
          block: popupVisible,
        })}
      >
        {props.children}
      </div>
    </div>
  )
}
